import { spacer16, spacer24 } from '@spotify-internal/encore-foundation';
import styled, { css } from 'styled-components';
import { browserFocusReset, cssColorValue, semanticColors, visuallyHidden, zIndexSkipLink } from "../../styles";
export var Link = styled.a.withConfig({
  displayName: "Link",
  componentId: "sc-1rnxmqt-0"
})(["", " position:absolute;top:0;left:0;display:inline-block;background-color:", ";padding-block-start:", ";padding-inline-end:", ";padding-block-end:", ";padding-inline-start:", ";text-decoration:none;z-index:", ";[dir='rtl'] &{left:unset;right:0;}", ""], function (props) {
  return !props.useBrowserDefaultFocusStyle && browserFocusReset;
}, cssColorValue(semanticColors.backgroundBase), spacer16, spacer16, spacer24, spacer16, zIndexSkipLink, function (props) {
  return !props.isFocus && css(["&:not(:focus){", "}"], visuallyHidden());
});